<script lang="ts">
  import { ContainerFullWidth } from '@shared/ui/fw-container';
  import { Icon } from '@shared/ui/icon';

  import { sections } from '../configs';
</script>

<ContainerFullWidth classes="3xl:max-w-[1512px] 4xl:max-w-[1626px] md:mx-auto xl:mx-auto">
  <div
    class="no-scrollbar flex gap-12 overflow-auto px-5 md:grid md:grid-cols-2 md:gap-8 md:px-0 xl:grid-cols-4 xl:gap-12"
  >
    {#each sections as section}
      <li class="flex w-10/12 shrink-0 list-none flex-col text-lg md:w-full">
        <Icon name="{section.icon}" width="{24}" height="{24}" classes="mb-5" />

        <h3 class="mb-4 flex items-start font-semibold md:min-h-[56px] lg:min-h-min xl:min-h-[56px]">
          {section.title}
        </h3>

        <p class="font-medium">
          {section.description}
        </p>
      </li>
    {/each}
  </div>
</ContainerFullWidth>
